module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-toggle row"
  }, [_c('div', {
    staticClass: "toggle-part left",
    class: {
      active: _vm.isActive(_vm.list[0])
    },
    on: {
      "click": function($event) {
        return _vm.setToggle(_vm.list[0])
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.list[0]) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "toggle-part right",
    class: {
      active: _vm.isActive(_vm.list[1])
    },
    on: {
      "click": function($event) {
        return _vm.setToggle(_vm.list[1])
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.list[1]) + "\n\t\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a97d0364"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Form/CustomToggle.vue
// module id = 1162
// module chunks = 0